export const initCarousel = function (config) {
  $('.carousel.side-by-side').each(function(){
    let items = $('.carousel-item', this).toArray();
    const minPerSlide = parseInt($(this).attr("data-items-per-slide"));
    items.forEach((el) => {
      let next = el.nextElementSibling;
      for (var i=1; i<minPerSlide; i++) {
        if (!next) {
          // wrap carousel by using first child
          next = items[0];
        }
        let cloneChild = next.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        next = next.nextElementSibling;
      }
    });
  });

  $(".carousel").each(function(){
    $(this).on("touchstart", function(event){
      let $carousel = $(this);
      var xClick = event.originalEvent.touches[0].pageX;
      $(this).one("touchmove", function(event){
        var xMove = event.originalEvent.touches[0].pageX;
        if( Math.floor(xClick - xMove) > 5 ){
          $carousel.carousel('next');
        }
        else if( Math.floor(xClick - xMove) < -5 ){
          $carousel.carousel('prev');
        }
      });
      $carousel.on("touchend", function(){
        $(this).off("touchmove");
      });
    });
  });

}
